import React, { FC } from "react";
import { ISponsor, SponsorsTypesProps } from ".";

import { Link } from "../../components";
import { extraSmallSponsors } from "../../contents";
import { SponsorList, SponsorItem, SponsorImage } from "./Sponsors.style";

const ExtraSmalls: FC<SponsorsTypesProps> = ({ list = extraSmallSponsors }) => {
  if (!list) return null;

  return (
    <SponsorList>
      {list.map((extraSmall) => (
        <SponsorItem key={extraSmall.id}>
          <Link href={extraSmall.site}>
            <SponsorImage
              src={extraSmall.image}
              alt={extraSmall.name}
              title={extraSmall.name}
              type="extraSmall"
            />
          </Link>
        </SponsorItem>
      ))}
    </SponsorList>
  );
};

export default ExtraSmalls;
